import { render, staticRenderFns } from "./virtualEvent.vue?vue&type=template&id=6c2658ba&scoped=true"
import script from "./virtualEvent.vue?vue&type=script&lang=js"
export * from "./virtualEvent.vue?vue&type=script&lang=js"
import style0 from "./virtualEvent.vue?vue&type=style&index=0&id=6c2658ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2658ba",
  null
  
)

export default component.exports